// Tabbed Content

let tabButtons = document.getElementsByClassName('tab-btn');
let tabMobileContent = document.getElementsByClassName('tab-content--mobile');

for(let i = 0, length = tabButtons.length; i < length; i++){

        if(tabButtons[i].nodeType===1){
            tabButtons[i].onclick = function(e){
                e.preventDefault();
                setActiveTab( tabButtons, this);
            };
        }
}

function setActiveTab(allButtons, thisButtons){
     let target = thisButtons.getAttribute('data-tab');

     // Set active buttons
     for(let j = 0, length2 = allButtons.length; j < length2; j++){
        if(allButtons[j].nodeType===1){

            if(target !== allButtons[j].getAttribute('data-tab')){
                allButtons[j].classList.remove('active');
            }
            else{
                thisButtons.classList.add('active');
                allButtons[j].classList.add('active');
            }
        }
     }

     // Set Active Mobile Tab content
     for(let k = 0, length3 = tabMobileContent.length; k < length3; k++){
        if(target !== tabMobileContent[k].getAttribute('data-tab')){
            tabMobileContent[k].classList.remove('active');
        }
        else{
            tabMobileContent[k].classList.add('active');
        }
     }

     // Set active tabs
     let allTabs = document.getElementsByClassName('tab_section--panel');

     for(let i = 0, length1 = allTabs.length; i < length1; i++){
         allTabs[i].classList.remove('active');
     }

     document.getElementById(target).classList.add('active');
}